// Shared navigation model for the authenticated app shell.
//
// One home link + a small set of dense, logical dropdown groups. Kept to ~6
// top-level groups so the bar fits on a normal laptop without overflowing
// (the personal account links — Profile, My Credits — live in the top-right
// user menu in AppShell, not here). AppShell filters leaves against
// config/rbac.js and drops a group when none of its children are visible, so
// each role sees only what it can use (a Messaging User sees Dashboard,
// Messaging, Notifications, Audience).

export const APP_MENU = [
  // Home — the personal messaging dashboard (every authenticated user).
  { label: 'Dashboard', icon: 'fa fa-gauge-high', to: '/dashboard' },

  // Sending — SMS.
  {
    label: 'Messaging',
    icon: 'fa fa-paper-plane',
    children: [
      { label: 'Compose SMS', icon: 'fa fa-paper-plane', to: '/compose-sms' },
      { label: 'Group SMS', icon: 'fa fa-bullhorn', to: '/group-sms' },
      { label: 'Bulk Upload', icon: 'fa fa-upload', to: '/bulk-messaging-upload' },
      { label: 'SMS Templates', icon: 'fa fa-file-lines', to: '/message-templates' },
    ],
  },

  // Sending — Email & Push channels.
  {
    label: 'Notifications',
    icon: 'fa fa-bell',
    children: [
      { label: 'Compose Email', icon: 'fa fa-at', to: '/email-compose' },
      { label: 'Email Templates', icon: 'fa fa-envelope-open-text', to: '/email-templates' },
      { label: 'Push Notifications', icon: 'fa fa-mobile-screen', to: '/push-notifications' },
    ],
  },

  // Who you send to.
  {
    label: 'Audience',
    icon: 'fa fa-address-book',
    children: [
      { label: 'Contacts', icon: 'fa fa-users', to: '/contact-management' },
      { label: 'Sender IDs', icon: 'fa fa-id-card', to: '/sender-id-request-queue' },
    ],
  },

  // Analytics + compliance trail (admin / compliance).
  {
    label: 'Reports & Logs',
    icon: 'fa fa-chart-line',
    children: [
      { label: 'System Dashboard', icon: 'fa fa-chart-pie', to: '/messaging-analytics-dashboard' },
      { label: 'Statistical Reports', icon: 'fa fa-file-invoice', to: '/statistical-reports' },
      { label: 'Message History', icon: 'fa fa-clock-rotate-left', to: '/audit-log-history' },
      { label: 'Activity Logs', icon: 'fa fa-shield-halved', to: '/audit-activity-logs' },
    ],
  },

  // Developer / system integration (admin / integration).
  {
    label: 'Integrations',
    icon: 'fa fa-code',
    children: [
      { label: 'Provider Settings', icon: 'fa fa-plug', to: '/provider-settings' },
      { label: 'API Settings', icon: 'fa fa-key', to: '/api-configuration' },
      { label: 'Webhooks', icon: 'fa fa-link', to: '/webhook-configuration' },
    ],
  },

  // Platform administration + service desk (admin).
  {
    label: 'Administration',
    icon: 'fa fa-user-shield',
    children: [
      { label: 'User Admin', icon: 'fa fa-users-cog', to: '/user-administration' },
      { label: 'Credit Allocation', icon: 'fa fa-coins', to: '/credit-allocation' },
      { label: 'Portal Content', icon: 'fa fa-pen-to-square', to: '/portal-content' },
      { label: 'Data Export', icon: 'fa fa-file-export', to: '/data-export' },
      { label: 'SLA Incidents', icon: 'fa fa-triangle-exclamation', to: '/sla-support-incidents' },
      { label: 'Training', icon: 'fa fa-graduation-cap', to: '/project-training-schedules' },
    ],
  },
];
